import CryptoJS from "crypto-js";
import { swal } from 'sweetalert';



export const EncryptData = (message, key) => {
  const encryptedText = CryptoJS.AES.encrypt(
    JSON.stringify(message),
    key
  ).toString();
  localStorage.setItem("POS--_AWQQWyAD4BSDSEWEWFELPOWD", encryptedText);
};

export const DecryptData = () => {
  const key = localStorage.getItem("token");
  const encryptedData = localStorage.getItem("POS--_AWQQWyAD4BSDSEWEWFELPOWD");

  if (encryptedData) {
    const bytes = CryptoJS.AES.decrypt(encryptedData, key);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    return decryptedData;
  }

  return null;
};


export const Logout = () => { 
  localStorage.clear();

  window.swal({
    icon : 'warning',
    text : 'Session Signed Out'
  }).then(() => {
    
    window.location.href = '/'
  } )


}
